import React, { useEffect, useState } from 'react';
import { useMap, useMapEvent } from 'react-leaflet';
import L from 'leaflet';
import { onSetActiveGeography, useGlobalActiveGeography, /*onSetCachedActiveIndicators,  onSetCachedSelectedIds, useGlobalCachedActiveIndicators, useGlobalCachedSelectedIds, onSetActiveIndicator, onSetBivariateIndicator*/ } from '../../data/StatusStore';
import Colors from '../utilities/Colors';
import { useGlobalHoveredId, useGlobalSelectedId } from '../../data/StatusStore';
import { siteConfig } from '../../config/siteConfig';

interface MapHighlightedFeatureProps {
  //onClickButton: () => void;
  dataJSON: any;
}

const MapHighlightedFeature: React.FC<MapHighlightedFeatureProps> = ({dataJSON }) => {
  const map = useMap();
  const activeGeography = useGlobalActiveGeography();

  //const [selectedValue, setSelectedValue] = useState<string>(activeGeography);

  const hoveredId = useGlobalHoveredId();
  const selectedId = useGlobalSelectedId();

  const lookupDescriptiveName = (activeGeography: string, hoveredId: string | null, selectedId: string | null) => {
    //console.log("A040325 activeGeography, hoveredId, selectedId", activeGeography, hoveredId, selectedId);
    const id = hoveredId || selectedId;
    if (!id) return "";
    const entry = dataJSON[id];
    if (!entry) return "";
    if (activeGeography === "CD") {
      return entry.MOA_GEONAME ?? entry.GEO_LABEL ?? "";
    } else {
      return entry.GEO_LABEL ?? "";
    }
  }
  useEffect(() => {
    // Create a Leaflet Control to position the radio buttons on the map
    const controlContainer = L.DomUtil.create('div', 'leaflet-control leaflet-bar');
    const customControl = new L.Control({ position: 'topright' }); // You can adjust the position

    customControl.onAdd = function() {
      L.DomEvent.disableClickPropagation(controlContainer);
      return controlContainer;
    };

    customControl.addTo(map);

    return () => {
      customControl.remove();
    };
  }, [map]);

  useMapEvent('click', () => {
    // Optional: Respond to map clicks or other events
  });
  //console.log("G071024 hoveredId", hoveredId);
  return (
    <div className="leaflet-control-container">
      <div className="leaflet-bottom leaflet-right">
        <div className="leaflet-control leaflet-control-custom"
          id='mapSelecedIdBox'
          style={{
            paddingBottom: "3px",
            paddingTop: "3px",
            paddingRight: "10px",
            paddingLeft: "10px",
            //cursor: "pointer",
            minHeight: "20px",
            minWidth: "140px",
            color: hoveredId ? Colors.highlightHover : Colors.highlightSelect, // "#ffffff",
            backgroundColor: "#faf5f5", //hoveredId ? Colors.highlightHover : Colors.highlightSelect,
            border: `1px solid ${hoveredId ? Colors.highlightHover : Colors.highlightSelect}`,
          }}
          //onClick={onClickButton}
        >
           {`${siteConfig.geographies[activeGeography]?.shortLabel ?? siteConfig.geographies[activeGeography]?.label ?? activeGeography} ${hoveredId ? hoveredId : selectedId}`}<br/>
           <b>{`${lookupDescriptiveName(activeGeography, hoveredId, selectedId)}`}</b>
        </div>
      </div>
    </div>
  );
};

export default MapHighlightedFeature;
